


export const LoadingTableSkeleton = ({ index, cols }) => {
  return (
    <tr key={index} className={`w-full`}>
      {(cols ? Array.from({ length: cols }) : [1, 2, 3, 4, 5, 6, 7]).map((i) => (
        <td key={i} className={`px-3 py-3 `}>
          <div className="w-full ">
            <div style={{ backgroundColor: "#DCE1F0" }} className="h-10 w-full rounded relative overflow-hidden before:absolute before:inset-0 before:bg-gradient-to-r before:from-gray-600 before:via-gray-500 before:to-gray-600 before:animate-shimmer" />
          </div>
        </td>
      ))}
    </tr>
  );
};

export const replaceMappingIdsWithVariables = ({ text, variables }) => {
  let updatedText = text;
  variables.forEach(({ variableName, mappingId, productName }) => {
    const mappingPattern = new RegExp(`\\{\\{${mappingId}\\}\\}`, "g"); // Match {{mappingId}}
    updatedText = updatedText.replace(mappingPattern, `{${productName}}`);
  });
  return updatedText;
};


export function secondsToString(seconds) {
  var numyears = Math.floor(seconds / 31536000);
  var numdays = Math.floor((seconds % 31536000) / 86400);
  var numhours = Math.floor(((seconds % 31536000) % 86400) / 3600);
  var numminutes = Math.floor((((seconds % 31536000) % 86400) % 3600) / 60);
  var numseconds = (((seconds % 31536000) % 86400) % 3600) % 60;

  const getFormat = ({ num, singular, plural }) => {
    return num === 0
      ? ""
      : num == 1
        ? ` ${num} ${singular} `
        : ` ${num} ${plural} `;
  };

  return [
    { num: numyears, singular: "yr", plural: "yrs" },
    { num: numdays, singular: "day", plural: "days" },
    { num: numhours, singular: "hr", plural: "hrs" },
    { num: numminutes, singular: "min", plural: "mins" },
    { num: numseconds, singular: "sec", plural: "secs" },
  ]
    .map(getFormat)
    .join(" ");
}

export function formatDuration(seconds, includeSeconds = false) {
  const units = [
    { label: "yr", value: 31536000 },
    { label: "day", value: 86400 },
    { label: "hr", value: 3600 },
    { label: "min", value: 60 },
  ];
  if (includeSeconds) units.push({ label: "sec", value: 1 });

  return (
    units
      .map(({ label, value }) => {
        const count = Math.floor(seconds / value);
        seconds %= value;
        return count > 0 ? `${count} ${label}${count > 1 ? "s" : ""}` : "";
      })
      .filter(Boolean)
      .join(" ") || "0 secs"
  );
}

export function calculateDuration(
  startTime,
  endTime,
  includeSeconds = false,
  returnSeconds = false
) {
  if (!startTime || !endTime) return returnSeconds ? 0 : "-";

  const seconds = Math.floor((new Date(endTime) - new Date(startTime)) / 1000);
  if (seconds < 0) throw new Error("endTime cannot be earlier than startTime");

  return returnSeconds ? seconds : formatDuration(seconds, includeSeconds);
}

export function generateAuthToken(length = 32) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let token = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    token += characters[randomIndex];
  }

  return token;
}

/**
 * Render a journey's Overall Verification Score for display.
 *
 * NULL is the "Unscored" state — a journey that produced no successful spoof
 * detection or face match calls. It is never 0 and never 100, so it must read
 * as its own thing rather than as a bad score.
 *
 * The value arrives as a Sequelize DECIMAL, which several dialects serialise as
 * a STRING ("88.30"), so coerce before formatting. Always returns a string: a
 * genuine score of 0 would otherwise be falsy and render as an em dash.
 */
export const formatVerificationScore = (score) => {
  if (score === null || score === undefined || score === "") return "Unscored";
  const numeric = Number(score);
  if (!Number.isFinite(numeric)) return "Unscored";
  // Stored to one decimal place; trim a trailing ".0" so 88.0 reads as 88.
  return String(Math.round(numeric * 10) / 10);
};

export const formatDate = (dateToConvert) => {
  const date = new Date(dateToConvert);

  const formattedDate = date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    hour12: true, // Use 12-hour format
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
  return formattedDate;

} 